module.exports = __webpack_public_path__ + "img/newRemove.4c63a0cb.svg";